module.exports = __webpack_public_path__ + "img/kai.2bc6fa28.png";